import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, Route } from 'react-router-dom';
import { PageHero, PageLoader } from '@kambria/kambria-lego';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faKey, 
  faUserTag, 
  faGraduationCap, 
  faCrown, 
  faQuestionCircle, 
  faEnvelope, 
  faSignOutAlt 
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import TokenPortal from '../token-portal';
import Profile from '../profile/index.js';
import ChangePassword from '../profile/ChangePassword.js';
import RoleSelection from './RoleSelection.js';
import SessionHistory from '../session-history';
import AccountBalance from '../account-balance';
import OrderHistory from '../order-history';
import NftLicense from '../nft-licenses';
import Message from 'views/components/core/message/Message';
import AwsFileUpload from 'views/components/core/AwsFileUpload';
import MyPackageContent from './MyPackageContent.js';

import { fetchUserMvp, updateProfilePicture, getUserProfileMvp, logOutMvp } from 'redux/actions/user.action';

import background from 'static/images/token-header.png';
import defaultAvatar from 'static/images/default_avatar.png';
import { I18n } from '../../../../helpers/i18n';
import Utils from '../../../../helpers/utils';

const DEFAULT_PAGE = '/user/profile';

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationCount: 0,
    };
    this.inputFileRef = React.createRef();
  }

  style = {
    backgroundColor: '#111827',
    height: 'auto',
    minHeight: '100vh',
  };

  async componentDidMount() {
    Object.keys(this.props.user || {}).length || this.props.fetchUserMvp();
    const { fetchUserMvp, getUserProfileMvp, updateUser } = this.props;
    const user = await getUserProfileMvp();

  }

  uploadDone = async (pictureUri) => {
    const { updateProfilePicture } = this.props;
    await updateProfilePicture(pictureUri);
  };

  onAvatarPickerClick = () => {
    const { updatingProfilePicture } = this.props;
    if (updatingProfilePicture) return;
    this.inputFileRef.current.click();
  };

  handleLogout = async () => {
    const { user, logOutMvp } = this.props;
    
    // Clear local storage and session storage
    localStorage.removeItem('ced:pathBeforeSignIn');
    localStorage.removeItem('ced:user-info');
    sessionStorage.removeItem('ced:previousUrl');
    
    // Call logout API
    if (user.accessToken) {
      await logOutMvp(user.accessToken);
    }
    
    // Remove cookies
    Utils.removeCookie('_RFT');
    localStorage.removeItem('ced:user-info');
    sessionStorage.removeItem('ced:previousUrl');
    
    // Redirect to home page
    window.location.replace('/');
  };

  getMvpUserTypeLabel = () => {
    const { user } = this.props;
    if (!user || !user.mvpUserType) {
      return null;
    }
    
    if (user.mvpUserType === 'explorer') {
      return I18n.t('account_type_selection_senior');
    } else if (user.mvpUserType === 'guide') {
      return I18n.t('account_type_selection_senior_buddy');
    } else if (user.mvpUserType === 'both') {
      return I18n.t('account_type_selection_senior');
    }
    
    return null;
  };

  renderUserIndex = () => {
    const { user, updatingProfilePicture, editting } = this.props;
    const MENU_ITEMS = [
      {
        linkTo: '/user/profile',
        text: I18n.t('profile'),
        icon: faUser,
        component: Profile,
      },
      {
        linkTo: '/user/change-password',
        text: I18n.t('change_password'),
        icon: faKey,
        component: ChangePassword,
      },
      {
        linkTo: '/user/role',
        text: I18n.t('role'),
        icon: faUserTag,
        component: RoleSelection,
      },
      // Temporarily hidden menus
      // {
      //   linkTo: '/user/professional-level',
      //   text: I18n.t('professional_level'),
      //   icon: faGraduationCap,
      //   component: Profile, // You may need to create a separate component for this
      // },
      {
        linkTo: '/user/membership-package',
        text: I18n.t('membership_package'),
        icon: faCrown,
        component: MyPackageContent,
        invisible: (mvpUserType) => !mvpUserType || (mvpUserType !== 'explorer' && mvpUserType !== 'both'),
      },
      {
        linkTo: 'https://kambria.io/docs/ced/',
        text: I18n.t('faqs'),
        icon: faQuestionCircle,
        component: Profile, // You may need to create a separate component for this
        isExternal: true,
      },
      {
        linkTo: 'mailto:ced@kambria.io',
        text: I18n.t('customer_support'),
        icon: faEnvelope,
        component: null,
        isExternal: true,
      },
      {
        linkTo: '/logout',
        text: I18n.t('log_out'),
        icon: faSignOutAlt,
        component: null,
        isLogout: true,
      },
    ];
    return (
      <main className="main" style={{ padding: 0, margin: 0, display: 'flex', justifyContent: 'center' }}>
        <div className="container user-portal" style={{ boxShadow: 'none', margin: 0, padding: 0, maxWidth: '1200px', width: '100%' }}>
          <div className="row" style={{ margin: '30px auto', backgroundColor: 'transparent' }}>
            <div className="col-12 col-lg-3 col-md-3 col-sm-12 p-30 m-0 text-center portal-menu" style={{ backgroundColor: 'transparent', borderRight: '1px solid #374151' }}>
              <div
                className="avatar"
                style={{
                  backgroundImage: `url(${user.avatarUrl || defaultAvatar})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  margin: '36px auto',
                }}
              >
                {editting && (
                  <div className="avatar-picker" onClick={this.onAvatarPickerClick}>
                    {updatingProfilePicture ? <PageLoader type="position" /> : <i className="fas fa-camera" />}
                    <AwsFileUpload
                      customStyle={{
                        position: 'absolute',
                        left: -9999,
                        top: -9999,
                      }}
                      fileRef={this.inputFileRef}
                      accept=".png, .jpg, .jpeg, .gif"
                      typePattern={/^image\/(png|jpg|jpeg|gif)$/}
                      maxSize={5}
                      path="userprofile/images/"
                      signals={{
                        onStart: 'UPLOAD_IMAGE',
                        onSuccess: 'UPLOAD_IMAGE_SUCCESS',
                        onFailure: 'UPLOAD_IMAGE_FAILED',
                      }}
                      prefix="avatar_"
                      uploadDone={this.uploadDone}
                    />
                  </div>
                )}
              </div>
              <div style={{ color: '#FFFFFF', fontSize: '24px', lineHeight: '130%', textAlign: 'center', marginBottom: '8px' }}>
                {user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.name || user.email}
              </div>
              <div style={{ color: '#FFFFFF', fontSize: '16px', lineHeight: '150%', textAlign: 'center' }}>
                {user.email}
              </div>
              <ul className="menu" style={{ listStyle: 'none', padding: 10, margin: 0 }}>
                {MENU_ITEMS.map((item, index) => {
                  const isActive = window.location.pathname === item.linkTo;
                  const isLogout = item.isLogout;
                  const isLastItem = index === MENU_ITEMS.length - 1;
                  const linkStyle = {
                    display: 'flex',
                    alignItems: 'center',
                    color: isLogout ? '#FF445D' : '#FFFFFF',
                    fontSize: '16px',
                    textDecoration: 'none',
                    padding: '0 12px',
                    transition: 'all 0.3s ease',
                  };

                  const handleClick = async (e) => {
                    if (item.isLogout) {
                      e.preventDefault();
                      // Handle logout logic here
                      await this.handleLogout();
                    }
                  };

                  const shouldHide = item.invisible && item.invisible(user && user.mvpUserType ? user.mvpUserType : null);
                  const isRoleItem = item.linkTo === '/user/role';
                  const mvpUserTypeLabel = isRoleItem ? this.getMvpUserTypeLabel() : null;
                  
                  return shouldHide ? null : (
                    <li key={item.linkTo} style={{ 
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      borderBottom: isLastItem ? 'none' : '1px solid rgb(55, 65, 81)',
                      backgroundColor: isActive ? '#6B7280' : 'transparent',
                      borderRadius: isActive ? '12px' : '0',
                      transition: 'all 0.3s ease',
                    }}>
                      {item.isExternal ? (
                        <a 
                          href={item.linkTo} 
                          style={linkStyle}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon 
                            icon={item.icon} 
                            style={{ 
                              marginRight: '12px', 
                              fontSize: '16px',
                              color: isLogout ? '#FF445D' : '#FFFFFF'
                            }} 
                          />
                          {item.text}
                        </a>
                      ) : (
                        <Link 
                          to={item.linkTo} 
                          style={linkStyle}
                          onClick={handleClick}
                        >
                          <FontAwesomeIcon 
                            icon={item.icon} 
                            style={{ 
                              marginRight: '12px', 
                              fontSize: '16px',
                              color: isLogout ? '#FF445D' : '#FFFFFF'
                            }} 
                          />
                          {item.text}
                        </Link>
                      )}
                      {isRoleItem && mvpUserTypeLabel && (
                        <span style={{ 
                          color: '#9CA3AF', 
                          fontSize: '14px',
                          marginLeft: 'auto',
                          paddingRight: 10
                        }}>
                          {mvpUserTypeLabel}
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-12 col-lg-9 col-md-9 col-sm-12 p-4 m-0 text-left portal-content" style={{ backgroundColor: 'transparent' }}>
              {MENU_ITEMS.map((item) => (
                item.component && <Route key={item.linkTo} path={item.linkTo} component={item.component} />
              ))}
              <Route exact key="/user" path="/user" component={() => <Redirect to={DEFAULT_PAGE} />} />
            </div>
          </div>
        </div>
      </main>
    );
  };

  render() {
    const { header, footer, user, loading } = this.props;
    const currentPath = window.location.pathname;
    const isUserPage = currentPath.startsWith('/user/');

    // Check if user is authenticated - must have accessToken
    const userData = localStorage.getItem('ced:user-info');
    let isAuthenticated = false;
    let parsedUser = null;
    
    if (userData) {
      try {
        parsedUser = JSON.parse(userData);
        isAuthenticated = !!(parsedUser && parsedUser.accessToken);
      } catch (e) {
        isAuthenticated = false;
      }
    }

    // Also check Redux store user if available
    const hasUserFromStore = user && (user.accessToken || user._id);
    const shouldShowContent = isAuthenticated || hasUserFromStore;

    // Redirect to login if not authenticated
    if (!loading && !shouldShowContent) {
      const historyUrl = window.location.href.replace(window.location.origin, "");
      sessionStorage.setItem('ced:previousUrl', historyUrl);
      toast.info(I18n.t('need_login_to_access'), {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
        className: 'toast-info-container',
      });
      return <Redirect to="/login" />;
    }

    return (
      <div id="site_wrapper" style={{ backgroundColor: '#111827' }}>
        <Message />
        <div className="site-upper" style={{ backgroundColor: '#111827', height: 'auto', minHeight: 'auto' }}>
          {header}
          {!isUserPage && <PageHero />}
        </div>
        {loading ? <PageLoader type="center" /> : shouldShowContent && this.renderUserIndex()}
        {footer}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
  editting: user.editting,
  loading: user.loading,
  updatingProfilePicture: user.updatingProfilePicture,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserMvp,
  updateProfilePicture,
  getUserProfileMvp,
  logOutMvp
});
export default connect(mapStateToProps, mapDispatchToProps)(User);
